// extracted by mini-css-extract-plugin
export default {"container":"Products_container__uMIWj","Products":"Products_Products__x2X55","menu":"Products_menu__koiGV","list":"Products_list__KPPDh","product":"Products_product__rPWhu"};